var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-footer"},[_c('social-btns'),_c('copy-right-msg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }